import { useLocaleField } from '@/hooks/useLocaleField';
import { sanityImage } from '@/utils/sanityImage';
import { useColorModeValue } from '@chakra-ui/color-mode';
import { Box, Flex, Heading, useMediaQuery } from '@chakra-ui/react';
import Image from 'next/image';
import Link from 'next/link';
import { FC } from 'react';
import { MotionBox } from '../MotionBox';
import styles from './RelatedRoomCard.module.css';
import { RelatedRoomCardProps } from './RelatedRoomCard.props';

const RelatedRoomCard: FC<RelatedRoomCardProps> = ({ relatedRoom, index }) => {
  const [isSmallerThan540] = useMediaQuery('(max-width: 540px)');
  const delay = isSmallerThan540 ? 0.2 : 0.2 * index;
  const { getLocaleField } = useLocaleField();

  return (
    <Link href={`/rooms/${relatedRoom.slug?.current}`}>
      <MotionBox
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ delay }}
      >
        <Box className={styles.CardWrapper}>
          <Box className={styles.ImageWrapper}>
            <Image
              src={sanityImage(relatedRoom?.coverImage)?.width(450).height(300).url() || ''}
              className={styles.Image}
              width={450}
              height={300}
              alt={getLocaleField(relatedRoom.name) || 'Room preview'}
            />
          </Box>
          <Flex alignItems="center" justifyContent="space-between">
            <Box>
              <Box mt={{ base: '1rem', md: '1.5rem' }}>
                <Box
                  color="gray.500"
                  fontWeight="semibold"
                  letterSpacing="wide"
                  fontSize="xs"
                  textTransform="uppercase"
                >
                  <>
                    {getLocaleField(relatedRoom.beds)}
                    {relatedRoom.hasBalcony && <span> &bull; Balcony </span>}
                  </>
                </Box>
              </Box>
              <Heading
                className={styles.RoomName}
                fontWeight="normal"
                as="h4"
                fontSize="1.5rem"
                color={useColorModeValue('gray.600', 'gray.400')}
              >
                {getLocaleField(relatedRoom.name)}
              </Heading>
            </Box>
            {relatedRoom?.price?.show_price&&
              <Box color="purple.700">
                <Box as="span" fontSize="xl">{getLocaleField(relatedRoom?.price.price)}</Box>
              </Box>
            }
          </Flex>
        </Box>
      </MotionBox>
    </Link>
  );
};

export { RelatedRoomCard };
